import {
	getBoxShadow,
	getBorderColor,
	getSubOptionPaddingLeft,
	getFontStyle,
	getOptionColor,
	getOptionBackground,
	getColor,
	getOptionCurrentColor,
} from "./computedStyles";

export const selectStyles = {
	indicatorSeparator: () => ({ display: "none" }),
	control: (provided, state) => ({
		...provided,
		height: 34,
		minHeight: 34,
		outlineColor: "rgba(255, 255, 255, 0.15)",
		background: "inherit",
		boxShadow: getBoxShadow(state),
		borderRadius: 0,
		borderColor: getBorderColor(state),
		"&:hover": {
			borderColor: getBorderColor(state),
		},
	}),
	input: provided => ({
		...provided,
		gridTemplateColumns: "0 auto",
		color: "#747474",
		fontSize: "0.875rem",
		"& input": {
			boxShadow: "none !important",
		},
	}),
	menu: provided => ({
		...provided,
		background: "#1c1c1c",
		borderRadius: 0,
		marginTop: 0,
		marginBottom: 0,
	}),
	menuList: provided => ({
		...provided,
		"&::-webkit-scrollbar": {
			width: "5px",
		},
		"&::-webkit-scrollbar-track": {
			background: "#292929",
		},
		"&::-webkit-scrollbar-thumb": {
			background: "#d4d4d4",
		},
		scrollbarWidth: "thin",
	}),
	option: (provided, state) => ({
		...provided,
		padding: "4px 12px",
		paddingLeft: getSubOptionPaddingLeft(state),
		color: getOptionCurrentColor(state),
		fontSize: "0.9375rem",
		fontStyle: getFontStyle(state),
		wordBreak: "break-all",
		background: state.isSelected ? "#13acc5" : "#1c1c1c",
		"&:hover": {
			color: getOptionColor(state),
			background: getOptionBackground(state),
		},
		"&:active": {
			color: getOptionColor(state),
			background: getOptionBackground(state),
		},
	}),
	valueContainer: provided => ({
		...provided,
		padding: "0 8px",
	}),
	singleValue: (provided, state) => ({
		...provided,
		color: getColor(state),
		fontSize: "0.9375rem",
	}),
	multiValue: provided => ({
		...provided,
		borderRadius: 0,
		backgroundColor: "#4d4d4d",
		color: "#747474",
	}),
	placeholder: provided => ({
		...provided,
		color: "rgba(255, 255, 255, 0.2)",
		fontSize: "0.875rem",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		overflow: "hidden",
		maxWidth: "calc(100% - 8px)",
	}),
	dropdownIndicator: (provided, state) => ({
		...provided,
		borderTopColor: state.isDisabled && "#252525",
	}),
	clearIndicator: provided => ({
		...provided,
		padding: 5,
	}),
	indicatorsContainer: provided => ({
		...provided,
	}),
	selectAsyncErrorMessage: () => ({
		position: "absolute",
		color: "#ba4545",
		fontSize: "12px",
	}),
	selectAsyncWarningMessage: () => ({
		position: "absolute",
		color: "#b88c05",
		fontSize: "12px",
	}),
};
